export const sanitizeInput = (value: string) => {
  return value.replace(/<\/?[^>]+(>|$)/g, '');
};
